<div class="anchoStepper">
  <div class="mibarra w-100 mt-1 mb-1" style="align-items: center">
    <div class="row">
      <div class="col-md-12 justify-content-start">
        <div class="d-flex justify-content-between align-items-center">
          <div class="step-text">
            <strong class="d-none d-sm-inline"
              >Paso {{ activeStep + 1 }} de 4:
            </strong>
            <span class="desktop">{{ actualStep[activeStep] }}</span>
            <span class="mobile"
              ><strong>{{ actualStep[activeStep] }}</strong></span
            >
          </div>
          <div *ngIf="activeStep !== 3" class="next-stop-text">
            Siguiente: {{ nextStep[activeStep] }}
          </div>
        </div>

        <div class="container-fluid p-2 align-items-center">
          <div class="d-flex justify-content-around">
            <span
              *ngFor="let step of [1, 2, 3, 4]; let i = index"
              [ngClass]="{
                'bg-custom': i < activeStep,
                'bg-custom-actual': i === activeStep,
                'bg-custom-success': i > activeStep,
              }"
              class="bg-success w-25 rounded mt-auto mb-auto me-1 ms-1 d-flex justify-content-center align-items-center"
              style="height: 0.3rem"
            >
              <img
                *ngIf="i === activeStep"
                [ngClass]="{
                  finalStep: i === activeStep && activeStep === 3
                }"
                src="./assets/img/motico.png"
                alt="seguro de moto precio" 
                style="width: 22px; height: 22px"
                class="motico-border"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
